export default __webpack_public_path__ + "static/media/blurple-chevron-down.a793a0f7.svg";